module.exports = __webpack_public_path__ + "47c3a082fba76fdac7afd334e3e6f7a9.png";